<div class="login-container">
  <div class="login-wrapper">
    <!-- Logo/Brand Section -->
    <div class="brand-section">
      <h1 class="brand-title">RLMS LTI 1.3 Platform Management Panel</h1>
    </div>

    <!-- Login Card -->
    <p-card class="login-card">
      <!-- Login Form -->
      <form [formGroup]="loginFormGroup" class="login-form" (ngSubmit)="onLogin()">
        <!-- Username Field -->
        <div class="field">
          <label>Relias Admin Username</label>
          <input
            pInputText
            id="username"
            type="text"
            formControlName="username"
            name="username"
            class="w-full"
            autocomplete="username"
          />
        </div>

        <!-- Password Field -->
        <div class="field">
          <label>Password</label>
          <p-password
            id="password"
            formControlName="password"
            name="password"
            [toggleMask]="true"
            [feedback]="false"
            styleClass="w-full"
            inputStyleClass="w-full"
            autocomplete="current-password"
          />
        </div>

        <!-- Login Button -->
        <p-button
          type="submit"
          label="Sign In"
          icon="pi pi-sign-in"
          [loading]="loading()"
          severity="contrast"
        />
      </form>
    </p-card>
  </div>
</div>